import { render, staticRenderFns } from "./AddAlert.vue?vue&type=template&id=723ac851&scoped=true"
import script from "./AddAlert.vue?vue&type=script&lang=js"
export * from "./AddAlert.vue?vue&type=script&lang=js"
import style0 from "./AddAlert.vue?vue&type=style&index=0&id=723ac851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723ac851",
  null
  
)

export default component.exports